import React from 'react';
import PropTypes from 'prop-types';

const Verified = ({ stroke }) => (
  <svg
    width="17px"
    height="19px"
    viewBox="0 0 17 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Verified Business</title>
    <g
      id="Listview-Jun-2020"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Listview-update-2020-ipad"
        transform="translate(-140.000000, -525.000000)"
        stroke={stroke}
        strokeWidth="1.5"
      >
        <g id="Group-13" transform="translate(16.000000, 358.000000)">
          <g id="Group-27-Copy-2" transform="translate(116.000000, 160.000000)">
            <g id="Group-43" transform="translate(9.000000, 8.000000)">
              <path
                d="M14.0277157,2.93227946 C12.8125177,2.69228951 9.78895094,1.94352086 7.70483814,0.157995639 C7.45474461,-0.0531955166 7.08922329,-0.0531955166 6.84233608,0.161195505 C4.7133347,2.00111845 1.74748187,2.7114887 0.538696448,2.93867919 C0.224476364,2.99627678 -0.00317287966,3.27146525 -2.22044605e-14,3.59145185 C0.0930169417,13.210249 2.56188902,14.8549802 6.96417652,16.934893 C7.15655616,17.0276892 7.38741173,17.0212894 7.57337872,16.9156939 C11.8506194,14.5221941 14.4445383,11.6391148 14.56,3.58505212 C14.5631724,3.26826539 14.3387295,2.99307691 14.0277157,2.93227946"
                id="Fill-1"
              />
              <polyline
                id="Path-2"
                points="4.48 7.93333333 6.72 10.7666667 11.2 5.66666667"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Verified.propTypes = {
  stroke: PropTypes.string,
};

Verified.defaultProps = {
  stroke: '#FFFFFF',
};

export default Verified;
